import { ENUM_MAP, strEnum } from "../../types";
import { SelectItem } from "primeng/primeng";
import { TCITenantAppType } from "./tci-application";

// TODO: update all TIB_APP_XYZ to real alert type
export const enum ALERT_TYPE_LABEL {
    TIB_APP_CPU = "CPU",
    TIB_APP_MEMORY = "Memory",
    TIB_APP_HIGH_FAULTED_EXECUTIONS = "High faulted executions",
    TIB_APP_INSTANCE_COUNT_0 = "Scale down",
    // TIB_APP_XYZ = "XYZ"
}
export const ALERT_TYPE = strEnum([
    "TIB_APP_CPU",
    "TIB_APP_MEMORY",
    "TIB_APP_HIGH_FAULTED_EXECUTIONS",
    "TIB_APP_INSTANCE_COUNT_0",
    // "TIB_APP_XYZ"
]);
export type ALERT_TYPE = keyof typeof ALERT_TYPE;

export interface ITCISupportRule {
    ruleName: string;
    threshold: string;
}

export const THRESHOLD_LIST_MAPPING: ENUM_MAP<ALERT_TYPE, ITCISupportRule[]> = new Map<ALERT_TYPE, ITCISupportRule[]>();
export type THRESHOLD_LIST_MAPPING = keyof typeof THRESHOLD_LIST_MAPPING;

export interface ITCIRule {
    ruleName: string;
    isEnabled: boolean;
    ruleGroup: string;
    description: string;
    threshold: string;
    thresholdList?: SelectItem[];
}


export const enum TCI_HOOK_STATUS {
    ACTIVE = "active",
    INACTIVE = "inactive",
}

export interface ITCIHook {
    id: string;
    name: string;
    url: string;
    status: TCI_HOOK_STATUS;
}

export interface ITCIHookStatus {
    message: string;
}

export const enum TCI_NOTIFICATION_SEVERITY {
    CRITICAL = "Critical",
    SEVERE = "Severe",
    HIGH1 = "High1",
    HIGH2 = "High2",
    HIGH3 = "High3",
}

export interface ITCINotification {
    appType: string;
    tenantType?: TCITenantAppType;
    alertName: string;
    description: string;
    appId: string;
    instanceId: string;
    severity: TCI_NOTIFICATION_SEVERITY;
    createTime: number;
}
